// extracted by mini-css-extract-plugin
module.exports = {"brandLi":"BrandEntry_brandLi__545zJ","brandEntry":"BrandEntry_brandEntry__QNRbM","accessibilityButton":"BrandEntry_accessibilityButton__0aBng"};